import IconButton from '@/components/Buttons/IconButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Ghost from '@/images/Ghost.svg';
import { fetchTemplateRawData } from '@/pages/AdvancedEditor/components/panels/templates/hooks';
import { IProjectTemplate } from '@d-id/types';
import styled from '@emotion/styled';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, Modal, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { StoreType } from 'polotno/model/store';
import { useEffect, useState } from 'react';
import { ListItemIcon, ListItemText } from '../components';
import { UpdateTemplateForm } from './UpdateTemplateForm';

const ModalContent = styled.div`
    position: absolute;
    border-radius: 8px;
    padding: 24px;
    overflow: auto;
    width: 50vw;
    background: white;
    font-size: 16px;
    max-height: 90vh;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

interface Props {
    template: IProjectTemplate;
    closeMenu: () => void;
}

export const UpdateTemplateMenuItem = ({ template, closeMenu }: Props) => {
    const [open, setOpen] = useState<boolean>(false);
    const [storeIsLoading, setStoreIsLoading] = useState(true);
    const [templateData, setTemplateData] = useState<StoreType | null>(null);

    const handleClose = () => {
        setOpen(false);
        closeMenu();
    };

    const handleOpen = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        e.stopPropagation();
        setOpen(true);
    };

    useEffect(() => {
        setStoreIsLoading(true);
        fetchTemplateRawData(template)
            .then(setTemplateData)
            .then(() => setStoreIsLoading(false));
    }, [template]);

    return (
        <MenuItem onClick={handleOpen} disabled={storeIsLoading}>
            <ListItemIcon sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                {storeIsLoading && <CircularProgress size="24px" />}
                <MaskedIcon src={Ghost} size="24px" />
            </ListItemIcon>

            <ListItemText>Update Template</ListItemText>

            <Modal open={open} onClose={handleClose}>
                <ModalContent>
                    <Header>
                        <Typography variant="h3">Update Template</Typography>

                        <IconButton ariaLabel="close" onClick={handleClose}>
                            <CloseIcon color="secondary" fontSize="large" />
                        </IconButton>
                    </Header>

                    <UpdateTemplateForm template={template} handleClose={handleClose} templateData={templateData} />
                </ModalContent>
            </Modal>
        </MenuItem>
    );
};
